<p>
  inbox-dropdown works!
</p>
